import React, {useMemo, useState} from 'react';
import styles from './ProfileUserInfo.module.css'
import LayoutContentWrapper from "../../../components/Layout/LayoutContentWrapper/LayoutContentWrapper";
import Input from "../../../components/Utils/Inputs/Input/Input";
import {useAppDispatch, useAppSelector} from "../../../hooks/redux";
import {getUser} from "../../../store/selectors/authSelector";
import {UIText} from "../../../enums/UIText/UIText";
import {getLanguage} from "../../../store/selectors/appSelector";
import {getTextByLanguage} from '../../../enums/utils/getTextByLanguage';
import Buttons, {EnumButtonType, EnumButtonWeight, EnumColors} from '../../../components/Utils/Buttons/Buttons/Buttons';
import {toast} from "react-toastify";
import PhoneInput from "react-phone-number-input/input";
import {updateProfileThunk} from "../../../store/actions/AuthActions";

const ProfileUserInfo = () => {

    const user = useAppSelector(getUser)

    const language = useAppSelector(getLanguage)

    const [lastName, setLastName] = useState<string>(user?.lastName ? user.lastName : '')
    const [firstName, setFirstName] = useState<string>(user?.firstName ? user.firstName : '')
    const [secondName, setSecondName] = useState<string>(user?.secondName ? user.secondName : '')
    const [organization, setOrganization] = useState<string>(user?.organization ? user.organization : '')
    const [phone, setPhone] = useState(user?.phone ? user.phone : '')
    const [email, setEmail] = useState(user?.email ? user.email : '')


    const formConfig = useMemo(() => {
        return [
            [
                {
                    title: UIText.user.lastName.title,
                    defaultValue: lastName,
                    setValue: setLastName,
                    placeholder: UIText.user.lastName.title,
                    type: 'text'
                },
                {
                    title: UIText.user.firstName.title,
                    defaultValue: firstName,
                    setValue: setFirstName,
                    placeholder: UIText.user.firstName.title,
                    type: 'text'
                },
                {
                    title: UIText.user.secondName.title,
                    defaultValue: secondName,
                    setValue: setSecondName,
                    placeholder: UIText.user.secondName.title,
                    type: 'text'
                }
            ],
            [
                {
                    title: UIText.user.email.title,
                    defaultValue: email,
                    setValue: setEmail,
                    placeholder: UIText.user.email.title,
                    type: 'text'
                },
                {
                    title: UIText.user.phone.title,
                    defaultValue: phone,
                    setValue: setPhone,
                    placeholder: UIText.user.phone.title,
                    type: 'phone'
                }
            ],
            [
                {
                    title: UIText.user.organization.title,
                    defaultValue: organization,
                    setValue: setOrganization,
                    placeholder: UIText.user.organization.title,
                    type: 'text'
                },
            ]
        ]
    }, [email, firstName, lastName, organization, phone, secondName])


    const dispatch = useAppDispatch()
    const [isLoading, setIsLoading] = useState<boolean>(false)


    const handlerSubmit = () => {

        setIsLoading(true)
        if (user) {
            const dto = {
                id: user.id,
                data: {
                    lastName,
                    firstName,
                    secondName,
                    organization,
                    phone: String(phone),
                    email
                }

            }

            dispatch(updateProfileThunk(dto))
                .then(() => {
                    setIsLoading(false)
                    toast.success('Данные обновлены')
                })
                .finally(() => {
                    setIsLoading(false)
                })

        }

    }

    //TODO Сделать форму отдельной компонентой


    return (
        <div className={styles.formWrapper}>
            <LayoutContentWrapper customClassNameContentWrapper={styles.inputsWrapper}>
                <div className={styles.inputsFormWrapper}>
                    {formConfig.map((rowData, indexRow) => {
                        return (<div key={`${indexRow}_profileInputsRow`} className={styles.inputsRowWrapper}>
                            {rowData.map((data, indexElement) => {

                                    switch (data.type) {
                                        case 'text': {
                                            return (
                                                <div className={styles.inputWrapper} key={`${indexElement}_profileInput`}>
                                                    <h3 className={styles.inputTitle}>
                                                        {getTextByLanguage(data.title, language)}
                                                    </h3>
                                                    <Input
                                                        className={styles.inputElement}
                                                        placeholder={getTextByLanguage(data.title, language)}
                                                        type={data.type}
                                                        defaultValue={data.defaultValue}
                                                        onChange={(e) => data.setValue(e.target.value)}
                                                    />
                                                </div>
                                            )
                                        }

                                        case 'phone': {
                                            return (
                                                <div className={styles.inputWrapper} key={`${indexElement}_profileInput`}>
                                                    <h3 className={styles.inputTitle}>
                                                        {getTextByLanguage(data.title, language)}
                                                    </h3>
                                                    <PhoneInput
                                                        useNationalFormatForDefaultCountryValue={true}
                                                        className={styles.phoneInput}
                                                        country="RU"
                                                        international
                                                        withCountryCallingCode
                                                        // @ts-ignore
                                                        onChange={setPhone} value={phone}/>
                                                </div>
                                            )
                                        }

                                        default: {
                                            return toast.error('Ошибка в форме? неправильный типа поля')
                                        }
                                    }
                                }
                            )}
                        </div>)
                    })}
                    <Buttons
                        loading={isLoading}
                        disabled={isLoading}
                        className={styles.buttonSave}
                        color={EnumColors.white}
                        weight={EnumButtonWeight.fat}
                        type={EnumButtonType.filled}
                        onClick={handlerSubmit}>
                        {getTextByLanguage(UIText.actions.save, language)}
                    </Buttons>
                </div>
            </LayoutContentWrapper>
        </div>
    );
};

export default ProfileUserInfo;